export const GET_OTP_V1 = "/orp/bfe/api/portal-service/otp/v1/send-otp";
export const SUCCESS_CODE = 200;
export const SUCCESS = "success";
export const LIMIT_EXHAUST_STATUS = "502";
export const SOMETHING_WENT_WRONG = "Something Went Wrong!";
export const ATTEMPTS_LEFT_CODE = "2003";
export const OTP_INVALID_CODE = 2003;
export const OTP_ATTEMPTS_EXHAUSTED_CODE = 2002;
export const VERIFY_OTP_AND_AM_USER = `/auth/bfe/api/portal-service/otp/v1/verify-user`;
export const VERIFY_OTP_V1 = "/orp/bfe/api/portal-service/otp/v1/verify-otp";
export const HBB_LEADS = "HBB_LEADS";
export const PAYMENT_MODE_SMARTCASH = "PAYMENT_MODE_SMARTCASH"
export const INTIATE_PAYMENT_AM_PIN = `/orp/bfe/api/portal-service/transaction/v1/auth/initiate`;
export const PROCESS_TRXN_AM_PIN = `/orp/bfe/api/portal-service/transaction/v1/auth/process`;
export const CHECK_STATUS = "/orp/bfe/api/portal-service/transaction/v1/status?tid=";
export const ENTERPRISE = "ENTERPRISE";
export const INTIATE_PAYMENT = '/orp/bfe/api/portal-service/transaction/v1/initiate';
export const PROCESS_TRXN = '/orp/bfe/api/portal-service/transaction/v1/process';
export const GA_CURRENCY = "CFA";
export const AIRTEL_MONEY = "AIRTEL_MONEY";
export const AIRTEL_MONEY_PUSH = "AIRTEL_MONEY_PUSH";
export const CHECK_AM_STATUS = "/orp/bfe/api/portal-service/transaction/v1/status?tid=";
export const GA = "GA"
export const ORP = "ORP"
export const PAYSTACK_SELECTED = "PAYSTACK Selected";
export const MPESA = "MPESA"
export const IN_PROCESS = "IN_PROCESS"
export const RESEND_OTP_V1 = "/orp/bfe/api/portal-service/otp/v1/resend-otp";
export const INVOICE = "INVOICE"
export const GET_OTP = "/orp/bfe/api/portal-service/optimus/otp/send";
export const GET_LEAD_SUMMARY = "/api/portal-service/subscriber/order-summary";
export const RESEND_OTP = "/orp/bfe/api/portal-service/optimus/otp/resend";
export const VERIFY_OTP_URL_OPTIMUS = "/orp/bfe/api/portal-service/optimus/otp/verify";
export const AIRTEL_WEBSITE = "Airtel Website";
export const SMARTCASH = "SMARTCASH";
export const AM = "AM";
export const airtime = "airtime";
export const PG = "PG";
export const leadId = "leadId";
export const AIRTIME_EMAIL_ID = "airtime-email";
export const AIRTIME_MSISDN_ID = "airtime-msisdn";
export const CARD_EMAIL_ID = "card-email";
export const AW_FTTX = "AW_FTTX";
export const IND = "IND";
export const AM_MSISDN_ID = "airtel-money-msisdn";
export const SMARTCASH_MSISDN_ID = "smartcash-msisdn";
export const SMARTCASH_EMAIL_ID = "smartcash-email"
export const SMARTCASH_SECURE = "SMARTCASH_SECURE";
export const SMARTCASH_INCORRECT_PIN_CODE = "56D005";
export const PAYSTACK = "PAYSTACK";
export const AIR_TIME = "AIR_TIME";
export const HBB_AIRTIME = "HBB_AIRTIME";
export const PAYMENTCONFIG = "paymentOptionConfig";
export const AM_INCORRECT_PIN_CODE = "1004";
export const AM_PIN_LOCKED_CODE = "1006";
export const FTTX_INDIVIDUAL = "FTTX_INDIVIDUAL";
export const AIRTIME_RECHARGE = "AIRTIME_RECHARGE";
export const SMARTCASH_ACCOUNT_NOT_AVAILABLE_CODE = 4001;
export const SERVICE_CLASS_700_ERROR = 8021
export const SMARTCASH_ACCOUNT_LOCKED_DUE_TO_MULTIPLE_ATTEMPT = "56D0013";
export const SMARTCASH_SERVICE = "SmartCash";